/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  firebase: {
    apiKey: "AIzaSyD_c57WJWnG5-jXAt3-oOrEs6c8qXNmpIc",
    authDomain: "dindigulcamara.firebaseapp.com",
    databaseURL: "https://dindigulcamara-default-rtdb.firebaseio.com",
    projectId: "dindigulcamara",
    storageBucket: "dindigulcamara.appspot.com",
    messagingSenderId: "888291225398",
    appId: "1:888291225398:web:264a57626fe986643b4d97",
    measurementId: "G-7CEFJKTRWJ"
  },
  production: false,
  apiUrl:"https://rajamani-server.netlify.app/.netlify/functions/api"
};
